import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { AppDispatch, RootState } from '../../redux/store';
import { setSelectedUserId } from '../redux/usersSlice';

/** The user chosen in any admin page, shared by all of them and kept across navigation and reloads. */
export function useSelectedUser(): [string, (id: string) => void] {
    const dispatch = useDispatch<AppDispatch>();
    const selectedUserId = useSelector((state: RootState) => state.users.selectedUserId ?? '');
    const setSelected = useCallback((id: string) => dispatch(setSelectedUserId(id)), [dispatch]);
    return [selectedUserId, setSelected];
}
